export const NAME = 'loginReducer';
